/**
 * Order endpoints — wired to backend orders app
 */

import type { ApiEndpoint } from '../endpointsConfig'

export const orderEndpoints: ApiEndpoint[] = [
  // Cart operations (draft order)
  {
    name: 'cart',
    path: 'restohub-api/orders/cart/',
    actions: ['GET', 'DELETE'],
    tags: ['Order'],
  },
  {
    name: 'cartItem',
    path: 'restohub-api/orders/cart/items/',
    actions: ['POST'],
    tags: ['Order'],
  },
  {
    name: 'cartItemDetail',
    path: 'restohub-api/orders/cart/items/{id}/',
    actions: ['PATCH', 'DELETE'],
    tags: ['Order'],
  },

  // Checkout
  {
    name: 'checkoutValidate',
    path: 'restohub-api/orders/checkout/validate/',
    actions: ['POST'],
    tags: ['Order'],
  },
  {
    name: 'checkout',
    path: 'restohub-api/orders/checkout/',
    actions: ['POST'],
    tags: ['Order', 'Payment'],
  },
  {
    name: 'confirmPayment',
    path: 'restohub-api/orders/{id}/confirm-payment/',
    actions: ['POST'],
    tags: ['Order', 'Payment'],
  },

  // Customer order tracking
  {
    name: 'myOrders',
    path: 'restohub-api/orders/my-orders/',
    actions: ['LIST'],
    tags: ['Order'],
  },
  {
    name: 'orderTracking',
    path: 'restohub-api/orders/track/{id}/',
    actions: ['GET'],
    tags: ['Order'],
  },

  // Public order tracking by tracking code (no auth required)
  {
    name: 'publicOrderTracking',
    path: 'restohub-api/orders/track/{trackingCode}/',
    actions: ['GET'],
    tags: ['Order'],
  },

  // Cancel order within grace period
  {
    name: 'cancelOrder',
    path: 'restohub-api/orders/track/{trackingCode}/cancel/',
    actions: ['POST'],
    tags: ['Order'],
  },
]
